import React, { useState } from "react";
import styles from "./ActiveAvitoContainer.module.scss";
import { useDispatch, useSelector } from "react-redux";
import ScreenHeader from "../ScreenHeader/ScreenHeader";
import { AllChatsContainer } from "../AllChatsContainer/AllChatsContainer";
import { AllInfoAvitoContainer } from "../AllInfoAvitoContainer/AllInfoAvitoContainer";
import { setUpdateAvito } from "../../store/slices/avitoSlice";
import { ClipLoader } from "react-spinners";
import { toast } from "react-toastify";
import {
  configureAvitoClient,
  getAvitoIntegration,
} from "../../utils/api/actions/integrations/avito";

export const ActiveAvitoContainer = () => {
  const dispatch = useDispatch();

  const {
    activeAvito,
    updateAvito,
    updateAvitoData,
    isLoadingContent,
    isErrorAvito,
  } = useSelector((state) => state?.avito);

  const [activeNav, setActiveNav] = useState("all info");

  const errorEmptyAssistantId = () =>
    toast.error("Выберите ассистента!", {
      toastId: "customId",
    });

  const navItems = [
    {
      name: "Общая информация",
      value: "all info",
      component: <AllInfoAvitoContainer />,
    },
    {
      name: "Чаты",
      value: "chats",
      component: <AllChatsContainer />,
    },
  ];

  const valueObserver = (e) => {
    e.stopPropagation();
    setActiveNav(e.target.id);

    dispatch(
      getAvitoIntegration(activeAvito.userId, activeAvito.externalAvitoId)
    );
  };

  const renderNavItems = (arr) => {
    return arr.map((el, index) => {
      return (
        <div
          key={index}
          className={
            el.value === activeNav ? styles.activeNavItem : styles.navItem
          }
          id={el.value}
          onClick={valueObserver}
        >
          {el.name}
        </div>
      );
    });
  };

  const renderBodyItems = (arr) => {
    return arr
      .map((item, index) => {
        if (item.value === activeNav) {
          return <div key={item.value}>{item.component}</div>;
        }
        return null;
      })
      .filter(Boolean);
  };

  const onCancelEdit = () => {
    dispatch(setUpdateAvito(false));
  };

  const onSaveUpdatedData = () => {
    if (updateAvitoData.assistantId !== undefined || activeAvito.assistantID) {
      dispatch(
        configureAvitoClient(updateAvitoData, activeAvito.externalAvitoId)
      );
    } else {
      errorEmptyAssistantId();
    }
  };

  return (
    <div className={styles.container}>
      <ScreenHeader
        onCancelEdit={onCancelEdit}
        onSaveUpdatedData={onSaveUpdatedData}
        isEditing={updateAvito}
        title={"Интеграции"}
        path={"/integration"}
      />
      {isLoadingContent ? (
        <div className={styles.loaderContainer}>
          <ClipLoader color="#3e8fcb" size={90} />
          <div>Загрузка данных</div>
        </div>
      ) : (
        <>
          <div className={styles.navContainer}>{renderNavItems(navItems)}</div>
          <div
            className={styles.body}
            style={{
              height: isErrorAvito && "calc(80% - 40px)",
              justifyContent: isErrorAvito && "center",
            }}
          >
            {renderBodyItems(navItems)}
          </div>
        </>
      )}
    </div>
  );
};
